import React from 'react';
import { connect } from 'react-redux';

import { changeFieldProperty, removeFieldError, setFieldError } from 'apps/auth/actions/formAction';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import InputAutoDetect from 'apps/auth/components/form/InputAutoDetect';
import NewCardField from 'apps/auth/components/form/NewCardField';
import { getSortFields } from 'apps/auth/components/form-multi/utils';
import { DELIVERY_ALIPAY, DELIVERY_INTERAC, DELIVERY_PEOPLE_TRUST_INTERAC, DELIVERY_UPI } from 'apps/auth/constants/Constants';
import { ACCOUNT_TO } from 'apps/auth/constants/fieldsName';
import { PAN } from 'apps/auth/constants/FieldType';
import { AUTH_GA_POCKET } from 'apps/auth/constants/UrlConstants';
import { resolveArguments, toLowerCase } from 'apps/auth/helpers/utils';
import { selectHandlerPayee } from 'apps/auth/services/payeeServices';
import { getOnBlurHandler } from 'apps/auth/services/sendToFieldsService';

const ToFields = (props) => {
    const deliveryMethod = props.deliveryMethod;
    const formatAccountNumber =
        deliveryMethod !== DELIVERY_ALIPAY &&
        deliveryMethod !== DELIVERY_UPI &&
        deliveryMethod !== DELIVERY_INTERAC &&
        deliveryMethod !== DELIVERY_PEOPLE_TRUST_INTERAC;

    const getVisibleFields = () => {
        let visibleFields = [];
        getSortFields(props.fields).forEach((field) => {
            if (field.visible && field.destination === 'TO') {
                visibleFields.push(field);
            }
        });
        return visibleFields;
    };

    const selectHandler = (item) => {
        if (props.isPayee) {
            const newProps = {
                personalPlaceholder: props.personalPlaceholder,
                businessPlaceholder: props.businessPlaceholder,
                item,
                changeFieldProperty: props.changeFieldProperty,
                formName: props.formName,
            };
            return selectHandlerPayee(newProps);
        }
    };

    const type = props.fields[ACCOUNT_TO]?.type;
    const href = `${AUTH_GA_POCKET}${props.pocketId}/send`;
    const redirectByBinUrl = `${AUTH_GA_POCKET}${props.pocketId}/send/${props.toCountryCode}/${toLowerCase(props.toCurrencyCode)}/${
        deliveryMethod
    }/redirectByBin`;

    let rowButtonProps = {};
    if (props.regularFlow && !props.hideViewRates) {
        rowButtonProps = {
            buttonRowType: 'link',
            buttonRowCaption: props.ratesFirst,
            buttonRowHref: `${href}/${toLowerCase(props.toCountryCode)}/${toLowerCase(props.toCurrencyCode)}/${deliveryMethod}`,
            buttonRowOnClick: props.viewRatesFirst,
        };
    }
    return (
        <div>
            <HeaderPanel {...rowButtonProps} title={resolveArguments(props.recipient, props.toCountryName)} />
            {type === PAN && (
                <NewCardField
                    binExtraName="binInfo"
                    formName={props.formName}
                    panName={ACCOUNT_TO}
                    redirectByBinUrl={redirectByBinUrl}
                    countryIdForCard={props.toCountryId}
                />
            )}
            <fieldset>
                {getVisibleFields().map((field) => {
                    const onBlurHandler = getOnBlurHandler(props, field);
                    return (
                        <fieldset key={field.name}>
                            <InputAutoDetect
                                formName={props.formName}
                                defaultCountry={props.toCountryCode}
                                field={field}
                                selectHandler={selectHandler}
                                onBlurHandler={onBlurHandler}
                                formatAccountNumber={formatAccountNumber}
                            />
                        </fieldset>
                    );
                })}
            </fieldset>
        </div>
    );
};
const mapStateToProps = ({ extra, form, messages }, ownProps) => ({
    pocketId: extra.pocket?.id,
    deliveryMethod: extra.deliveryMethod,
    fields: form[ownProps.formName]?.fields,
    toCountryName: extra.toCountry?.name,
    toCountryCode: extra.toCountry?.code,
    toCountryId: extra.toCountry?.id,
    toCurrencyCode: extra.toCurrency?.code,
    recipient: messages.pageMessages.recipient,
    ratesFirst: messages.pageMessages.ratesFirst,
    hideViewRates: extra.profile?.hideViewRates,
    personalPlaceholder: messages.pageMessages.personalPlaceholder,
    businessPlaceholder: messages.pageMessages.businessPlaceholder,
    messages: messages.jsMessages,
});
export default connect(mapStateToProps, { setFieldError, removeFieldError, changeFieldProperty })(ToFields);
